/* eslint react/forbid-prop-types: 0 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductImage,
  ProductRating
} from '@thd-olt-component-react/product-pod';
import { Checkbox, SelectionControlLabel } from '@one-thd/sui-atomic-components';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';

export const BoughtTogetherPod = ({
  itemId,
  podIndex,
  storeId,
  isSelected,
  onSelectionChange
}) => {
  const [checked, setChecked] = useState(isSelected);

  // Sync local state when isSelected prop changes
  useEffect(() => {
    setChecked(isSelected);
  }, [isSelected]);

  const handleCheckboxChange = (event) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    if (onSelectionChange) {
      onSelectionChange({ itemId, checked: newChecked, podIndex });
    }
  };

  const analyticsData = {
    position: podIndex,
    parent: 'bought-together-carousel'
  };

  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-p-4 sui-bg-white sui-rounded sui-h-full">
      {/* Checkbox for selection */}
      <div className="sui-flex sui-items-start">
        <SelectionControlLabel value="true" label="Select">
          <Checkbox
            checked={checked}
            onChange={handleCheckboxChange}
            aria-label={`Select product ${itemId}`}
            data-testid={`bought-together-checkbox-${podIndex}`}
          />
        </SelectionControlLabel>
      </div>

      <ProductPod
        itemId={itemId}
        analyticsData={analyticsData}
        render={(pod) => {
          return (
            <div className="sui-flex sui-flex-col sui-gap-3">
              <div className="sui-w-full sui-flex sui-justify-center">
                <ProductImage itemId={pod.itemId} target="_blank" />
              </div>

              <div className="sui-flex sui-flex-col sui-gap-1">
                <ProductHeader
                  brand="inline"
                  itemId={pod.itemId}
                  titleMaxLine={3}
                  disableShopThisCollection
                  target="_blank"
                />
              </div>

              <div>
                <ProductRating itemId={pod.itemId} target="_blank" />
              </div>

              <div className="sui-mt-auto">
                <Price
                  itemId={pod.itemId}
                  large={false}
                  storeId={storeId}
                  displayEachUom={false}
                  showPreferredPricingBadge
                  hideForProductTypes={['HDQC']}
                  stackWasPrice
                />
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

BoughtTogetherPod.propTypes = {
  itemId: PropTypes.string.isRequired,
  podIndex: PropTypes.number.isRequired,
  storeId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onSelectionChange: PropTypes.func
};

BoughtTogetherPod.defaultProps = {
  isSelected: false,
  onSelectionChange: null
};

BoughtTogetherPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductHeader,
  ProductRating,
  Price
);
